
import React from 'react';
import "./PrescriptionPrint.css";
import { useContext } from "react";
import WaitingContext from "../../../store/waitingListContext";
import AuthContext from "../../../store/auth-context";
import { getPrescriptionHTML } from "./Templates/PrescriptionTemplates";

export const printPrescription = (patientData, medicines, hospitaData, checkedData, selectedDateTime, authCtx, isCasePaper = false, isHistory = false) => {
  const actualAuthData = authCtx?.hospitalData || {};
  
  // Logic to determine best hospital data source
  // If hospitaData is actually a patient record (has patientId) or is empty, use authCtx.hospitalData
  const usePropData = hospitaData && (hospitaData.prescriptionHeader || hospitaData.hospitalName);
  const hospitalData = usePropData ? hospitaData : actualAuthData;

  // Use doctor from patient record if available, otherwise from hospital config
  const patientRecord = patientData || hospitaData;
  const doctorName = (patientRecord?.doctorId?.firstName) 
    ? `${patientRecord.doctorId.firstName} ${patientRecord.doctorId.lastName}` 
    : hospitalData.doctorName;

  const brandingData = {
    ...hospitalData,
    doctorName: doctorName || hospitalData.doctorName
  };

  const selectedTemplate = brandingData.selectPrescription || "1";

  const htmlContent = getPrescriptionHTML(selectedTemplate, {
    patientData,
    medicines,
    hospitalData: brandingData,
    checkedData,
    selectedDateTime,
    authCtx,
    isCasePaper,
    isHistory
  });

  const printWindow = window.open("", "_blank", "width=900,height=650");
  if (!printWindow) return;

  printWindow.document.write(htmlContent);
  printWindow.document.close();
  printWindow.focus();
  printWindow.setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 250);
};

const PrescriptionPrint = ({ patientData, medicines, checkedData, selectedDateTime, children, className, hospitaData: propHospitaData, isHistory = false }) => {
  const authCtx = useContext(AuthContext);
  const prescriptionData = useContext(WaitingContext);
  
  // Use prop if passed, fallback to context
  const hospitaData = propHospitaData || prescriptionData?.waitingPatient;

  return (
    <button
      onClick={() => printPrescription(patientData, medicines, hospitaData, checkedData, selectedDateTime, authCtx, false, isHistory)}
      className={className || "pbtn"}
      title="Print Prescription"
    >
      {children || "Print"}
    </button>
  );
};

export default PrescriptionPrint;
